import PropTypes from 'prop-types';
import { Fragment, useState } from 'react';
import { ChevronDown, ChevronsUpDown, ChevronUp } from 'lucide-react';
import styles from './SimpleTable.module.css';

function SimpleTable({
  tableData,
  tableColumns,
  sortConfig,
  onSortChange,
  onRowClick
}) {
  const [selectedRow, setSelectedRow] = useState(null);

  const handleSort = (key) => {
    const direction =
      sortConfig.key === key && sortConfig.direction === 'asc'
        ? 'desc'
        : 'asc';

    onSortChange({ key, direction });
  };

  const toggleRow = (id, name) => {
    setSelectedRow((prev) => (prev === id ? null : id));
  };

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead className={styles.tableHead}>
          <tr className={styles.tableHeadRow}>
            {tableColumns.map((column) => (
              <th key={column.key} className={styles.tableCell}>
                <button
                  className={[
                    styles.sortButton,
                    sortConfig.key === column.key && styles.active
                  ].filter(Boolean).join(" ")}
                  onClick={() => handleSort(column.key)}
                >
                  {column.label}
                  <span className={styles.sortIcon}>
                    {sortConfig.key === column.key
                      ? (sortConfig.direction === 'asc'
                        ? <ChevronUp />
                        : <ChevronDown />)
                      : <ChevronsUpDown />}
                  </span>
                </button>
              </th>
            ))}
          </tr>
        </thead>

        <tbody className={styles.tableBody}>
          {/* Render row entries */}
          {tableData.map((row, index) => {
            const id = row.id ?? index;
            const isOpen = selectedRow === id;
            const rowName = row[tableColumns[0].key];
            return (
              <Fragment key={id}>
                <tr
                  className={[
                    styles.tableRow,
                    selectedRow === id && styles.selectedRow

                  ].filter(Boolean).join(" ")}
                  onClick={() => {
                    toggleRow(id, rowName);
                    if (onRowClick) {
                      onRowClick(row);
                    }
                  }}
                >
                  {tableColumns.map((col) => (
                    <td key={col.key} className={styles.tableBodyCell}>
                      {row[col.key]}
                    </td>
                  ))}
                </tr>
              </Fragment>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

SimpleTable.propTypes = {
  tableData: PropTypes.arrayOf(PropTypes.object).isRequired,
  tableColumns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  sortConfig: PropTypes.shape({
    key: PropTypes.string,
    direction: PropTypes.oneOf(['asc', 'desc']),
  }).isRequired,
  onSortChange: PropTypes.func.isRequired,
  onRowClick: PropTypes.func,
}

export default SimpleTable;